import { Component, Input, OnInit } from '@angular/core';
import { element } from 'protractor';
import { User, Location } from '../../models/user.model';
import { CountryReport } from '../../models/report.model';
import { LookupService } from '../../services/lookups/lookup.service';
import { AuthUserService } from '../../services/appInitialization/authUser.service';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'app-percentage-report-by-country',
  templateUrl: './percentage-report-by-country.component.html',
  styleUrls: ['./percentage-report-by-country.component.css']
})
export class PercentageReportByCountryComponent implements OnInit {
  occupiedRatio: number;
  remainRatio: number;
  countryReportCount: number;
  @Input() selectedCountryId: number;
  lessThanOne: boolean = false;;
  user: User = this.authUserService._user;
  constructor(private lookupService: LookupService,
              private authUserService: AuthUserService) { }

  ngOnInit(): void {
   
  }

  getCountryReportRatio(selectedCountryId, appUserId){
    this.lookupService.GetPercentageReportByCountry(selectedCountryId, appUserId)
      .pipe()
      .subscribe((result: CountryReport)=>{
        this.countryReportCount = result.countryReportCount;
        this.occupiedRatio = Math.round(result.countryReportCount / result.totalReportCount * 100);
        this.remainRatio = 100 - this.occupiedRatio;
        var occupied = document.getElementById('country-bar-occupied');
        var remain = document.getElementById('country-bar-remain');
        var container = document.getElementById('country-bar-container');
        if(this.countryReportCount < 1){
          container.style.display = "none";
        }
        else{
          container.style.display = "inline-block";
          if(this.occupiedRatio < 1){
            this.lessThanOne = true;
            occupied.style.width = (0.5).toString() + "%";
            remain.style.marginLeft = "0.5%";
            remain.style.width = (99).toString() + "%";
          }
          else{
            this.lessThanOne = false;
            occupied.style.width = (this.occupiedRatio).toString() + "%";
            remain.style.marginLeft = "0.5%";
            remain.style.width = (this.remainRatio - 0.5).toString() + "%";
          }
        }
      });
  }

}
